
  <ul class="filters-wrapper" >

  	<li class="facets input">

      <app-input class="input-element" [pageParams$]="pageParams$" [queryParams]="(pageParams$ | push).queryParams" ></app-input>
  		
  	</li>
    <ng-container *ngFor="let facets of getEntries(allFacets$ | push); trackBy: trackByMethod" >
      <li class="facets" *ngIf="showSection(facets[0]) && hasFacets(facets[1])" >
        <app-icon class="filter-icon" name="filter"></app-icon>
        <p>{{getGroupName(facets[0])}}</p>

        <nav class="facets-wrapper" >
          <ng-container *ngFor="let facet of facets[1]">
            <app-facet class="button" 
                [chip]="facet"
              ></app-facet>
          </ng-container>
        </nav>
      </li>
    </ng-container>
    

  	<li class="reset-button"  *ngIf="(pageParams$ | push).activeFilters.length !== 0">
  		<a 
  			class="button reset"
  			[routerLink]="'./'" 
  			[queryParams]="{}"
  			title="zrušit všechny filtry"
  			matRipple
  			>
  			<span class="label">Zrušit filtry</span>
  			
  			
  		</a>
  	</li>
  	
  </ul>


